<template>
	<main>
        <section>
            <div class="content-960">
                <div class="row">
                    <section class="col-sm-6">
                        <ul class="breadcrumb">
                            <li><a href="#" title="Home">Home</a></li>
                            <li><a href="#" title="Pages">Gerencial</a></li>
                            <li>Parâmetro</li>
                        </ul>
                    </section>

                </div>
            </div>

            <div class="content-960 mobile-row">
                <div class="wrapper-960 clearfix">
                    <div class="titles icons icon-news-middle">
                        <h2 class="uppercase"><b>Editar Parâmetro</b></h2>
                    </div>

                    <div class="mold-txt-center">
                        <form-edit v-if="dialogEdit" :id="parametroId" @on-saved="onSaved" @on-back="onBack()" />
                    </div>

                </div>
            </div>
        </section>


    </main>

</template>
<script>

    import formEdit from './form-edit'

    export default {
        name: 'parametro-edit',
        components: { formEdit },
        data: () => ({
            dialogEdit: false,
			parametroId: 0
        }),
        methods: {
            onSaved: function (data) {
				if (data) this.$router.push({ path: '/parametro' });
            },
            onBack: function () {
                this.$router.go(-1);
            }
        },
		mounted() {
			this.parametroId = +this.$route.params.id;
			this.dialogEdit = true;
        }
    };
</script>

